import { Component, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { Router } from '@angular/router';

import * as encoding from 'encoding-japanese';

import { ItemService } from '../../../service/item/item.service';
import { CsvReportService } from '../../../service/csv-report/csv-report.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { HeaderComponent } from '../../../../app/menu/header/header.component'
import { environment } from '../../../../environments/environment';
import { config } from '../../../util/config';
import { ItemPostDataSource } from '../../../classes/dataSource/itemPostDataSource';
import { ExportData } from '../../../classes/exportData/exportData';
import { insertcomma } from '../../../util/util';
import { AgGridHelper } from '../../../util/AgGridHelper';
import { GridButtonRenderComponent } from '../../../render/grid-button-render.component';

@Component({
  selector: 'app-root',
  templateUrl: 'wa9100.component.html',
  styleUrls: ['wa9100.component.scss']
})

export class Wa9100Component implements AfterViewInit {
  private gridApi: any;
  public componentTitle = 'WA9100:商品マスタ照会';

  @ViewChild(HeaderComponent)
  private headerComponent: HeaderComponent;

  public gridOptions: GridOptions;
  public showGrid: boolean;
  public rowData: any[];

  public ownerId: number;
  public ownerResult: any;

  public config = config;

  public working = false;
  public containerHeight = 500;
  public cardHeight = 500;
  public gridHeight = 500;
  public production = environment.production;
  public backgroundColor: string;

  private postDataSource: ItemPostDataSource;
  private isDatasourceInit: boolean = false;
  private isOwnerLinked: boolean = false; //荷主ユーザかどうか

  @ViewChild('gridView')
  private gridView: ElementRef;
  private gridHelper: AgGridHelper;

  private errorInfo = '';

  private paginationGetRowCount = 0;
  private paginationGetTotalPages = 0;
  private paginationGetCurrentPage = 0;
  private paginationGoToFirstPage;
  private paginationGoToNextPage;
  private selectedCount = 0;

  public rowsPerPageModel = [{ value: 500, viewValue: '500' }, { value: 5000, viewValue: '5000' }];
  public rowsPerPage = config.rowsPerPageSize;

  private isShowDeleteModal = false;

  private isEnableClearFilter = false;
  private isShowWa9101 = false;
  private isShowWa9102 = false;
  private isShowWa9183 = false;

  private isRefreshAndCheckNewData = false;
  private isRefreshAndCheckUpdateData = false;

  private isCompanyArrivlabeluseFl = this.commonService.isCompanyArrivlabeluseFl(JSON.parse(sessionStorage.getItem('ownerFunctions')).ownerFunctions);
  private isCompanyShiplabeluseFl = this.commonService.isCompanyShiplabeluseFl(JSON.parse(sessionStorage.getItem('ownerFunctions')).ownerFunctions);

  private isOwnerSearchNone = false;

  private isShowCSVDownloadModal = false;
  private csvDownloadType = null;
  private errorInfoForCSV = '';
  private isCSVDownloadButtonEnabled = false;
  private editNode = null;
  private gridSelectAll = false;

  private deleteErrorMsgForPopup = null;
  private isShowSendLoading = false;

  constructor(
    private router: Router,
    private itemService: ItemService,
    private csvReportService: CsvReportService,
    private commonService: CommonService,
    private dialogsService: DialogsService,
  ) {
    this.gridHelper = new AgGridHelper();
    this.ownerResult = sessionStorage.getItem('ownerResult');
    if (this.ownerResult !== null) {
      const selectedOwner = JSON.parse(this.ownerResult);
      this.ownerId = selectedOwner.ownerId;
    }
    const result = JSON.parse(sessionStorage.getItem('loginResult'));
    const querystrings = (this.ownerId) ? { 'ownerId': this.ownerId } : '';
    //SessionStorageからユーザ情報を取得、荷主ユーザか判定
    if (result !== null) {
      let user = result.user;
      this.isOwnerLinked = user.roleId == 3 ? true : false;
    }
    this.postDataSource = new ItemPostDataSource({
      parent: this,
      service: this.itemService,
      resultKey: 'items',
      querystrings: querystrings,
      beforeRequest: this.handleBeforeRequest.bind(this),
      successCallback: this.handleRequestSucc.bind(this)
    });
    this.gridOptions = <GridOptions>{
      rowSelection: 'multiple',
      floatingFilter: true,
      enableRangeSelection: true,
      localeText: environment.gridLocale,
      getContextMenuItems: this.getContextMenuItems,
      pagination: true,
      rowModelType: 'infinite',
      paginationPageSize: this.rowsPerPage,
      enableServerSideSorting: true,
      enableServerSideFilter: true,
      cacheBlockSize: Number(this.rowsPerPage),
      onColumnResized: this.saveColumnWidth,
      shohwLoadingOverlay: true,
      onColumnMoved: () => {
        this.saveColumnOrder();
      },
      onGridReady: params => {
        this.gridApi = params;
        const columns = [];
        for (const column of params.columnApi.getAllDisplayedColumns()) {
          const idx = localStorage.getItem(`wa9100_${column.getColId()}_idx`);
          if (idx !== null) {
            columns.push({ idx: parseInt(idx, 10), column: column });
          }
        }
        columns.sort((a, b) => {
          return a.idx - b.idx;
        });
        for (let i = columns.length - 1; i >= 0; i--) {
          const column = columns[i];
          params.columnApi.moveColumn(column.column, column.idx);
        }
        this.gridHelper.onGridReady();
        this.gridHelper.renderGridCheckboxImage();
        this.gridOptions.api.paginationSetPageSize(this.rowsPerPage);
        this.fixedSelectAll()
      },
      onFilterChanged: () => {
        this.errorInfo = '';
        this.isEnableClearFilter = this.gridOptions.api.isAnyFilterPresent();
        // this.gridHelper.onGridFilterChanged();
        this.gridHelper.renderGridCheckboxImage();
      },
      onPaginationChanged: () => {
        if (this.postDataSource['init'] == false) return;
        this.paginationGetRowCount = this.gridOptions.api.paginationGetRowCount();
        this.paginationGetTotalPages = this.gridOptions.api.paginationGetTotalPages();
        this.paginationGetCurrentPage = this.gridOptions.api.paginationGetCurrentPage() + 1;
        this.gridHelper.renderScrollArrow();
        this.gridHelper.renderGridCheckboxImage();

        if (this.isRefreshAndCheckNewData == true && this.gridOptions.api.getDisplayedRowCount() > 0) {
          var latestDateStr = null;

          this.gridOptions.api.forEachNode((node) => {
            var v = node.data;
            if (latestDateStr == null) {
              latestDateStr = v['addDt'];
            }
            else {
              var latestDate = new Date(Date.parse(latestDateStr.replace(/-/g, "/")));
              var curDate = new Date(Date.parse(v['addDt'].replace(/-/g, "/")));
              if (curDate.getTime() > latestDate.getTime()) {
                latestDateStr = v['addDt'];
              }
            }
          });
          setTimeout(() => {
            this.gridOptions.api.forEachNode((node) => {
              if (node.data['addDt'] === latestDateStr)
                this.gridHelper.prepareSelectedAnimateByNodes([node]);
            });
            this.gridHelper.selectedAnimateDelay();
          }, 100);
          this.isRefreshAndCheckNewData = false;
        }
        this.gridHelper.onRowDataChanged();

        this.selectedCount = 0;

        if (this.gridSelectAll) {
          this.selectAllClick()
        }
      },
      onRowDataChanged: () => {
        this.errorInfo = '';
        this.gridHelper.onRowDataChanged();

        this.selectedCount = 0;
        this.gridHelper.renderGridCheckboxImage();
      },
      overlayLoadingTemplate: this.gridHelper.TEMPLATE_GRID_LOADING,
      overlayNoRowsTemplate: this.gridHelper.TEMPLATE_GRID_NODATA,
      postProcessPopup: params => {
        this.errorInfo = '';
        this.gridHelper.fixedAgMenu();
      },
      onSortChanged: () => {
        this.errorInfo = '';
        this.gridHelper.renderGridCheckboxImage();
      },
      onSelectionChanged: () => {
        this.errorInfo = '';
        this.selectedCount = this.gridOptions.api.getSelectedRows().length;
      }
    };
    this.gridOptions.columnDefs = [
      {
        headerName: '',
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        width: 30,
        checkboxSelection: true,
        suppressSorting: true,
        suppressFilter: true,
        pinned: 'left',
        cellClass: ['tc', 'cl_w', 'noCellFocus']
      },
      {
        headerName: '',
        field: 'col1',
        pinned: 'left',
        suppressMenu: true,
        width: 95,
        cellClass: ['tc', 'cellclass'],
        cellStyle: this.isOwnerLinked?{ display: 'none' }:{},
        suppressMovable: true,
        cellRendererFramework: GridButtonRenderComponent,
        cellRendererParams: {
          buttonText: '修正',
          buttonStyle: this.isOwnerLinked? 'dspnone' : '',
          onClick: this.onEditButtonClick.bind(this)
        }
      },
      {
        field: 'itemId',
        hide: true
      },
      {
        headerName: '商品コード',
        field: 'itemCd',
        sort: 'asc',
        width: this.getColumnWidth('itemCd', 140),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass', 'textFormat']
      },
      {
        headerName: '商品名',
        field: 'itemTx',
        width: this.getColumnWidth('itemTx', 200),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '入荷ラベル数量指定',
        field: 'arrivlabeluseFlTx',
        width: this.getColumnWidth('arrivlabeluseFlTx', 150),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass'],
        hide: !(this.isCompanyArrivlabeluseFl)
      },
      {
        headerName: '出荷ラベル印刷',
        field: 'shiplabeluseFlTx',
        width: this.getColumnWidth('shiplabeluseFlTx', 120),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass'],
        hide: !(this.isCompanyShiplabeluseFl)
      },
      {
        headerName: 'ロット管理',
        field: 'lotFlTx',
        width: this.getColumnWidth('lotFlTx', 140),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '期限管理',
        field: 'uselimitFlTx',
        width: this.getColumnWidth('uselimitFlTx', 140),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '割れ物注意マーク印刷',
        field: 'fragilemarkFlTx',
        width: this.getColumnWidth('fragilemarkFlTx', 160),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '天地無用マーク印刷',
        field: 'upwardmarkFlTx',
        width: this.getColumnWidth('upwardmarkFlTx', 140),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '商品ラベル印刷',
        field: 'itemlabeluseFlTx',
        width: this.getColumnWidth('itemlabeluseFlTx', 140),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '商品カテゴリ',
        field: 'typeitemTx',
        width: this.getColumnWidth('typeitemTx', 100),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '同一商品カテゴリでの格納引当',
        field: 'sameitemapplyFlTx',
        width: this.getColumnWidth('sameitemapplyFlTx', 200),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '温度帯区分',
        field: 'typecoldTx',
        width: this.getColumnWidth('typecoldTx', 100),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '入荷時・使用期限アラート日数',
        field: 'arriveuselimitNr',
        width: this.getColumnWidth('arriveuselimitNr', 210),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '出荷時・使用期限アラート日数',
        field: 'shipuselimitNr',
        width: this.getColumnWidth('shipuselimitNr', 210),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '単位名',
        field: 'pcsunitTx',
        width: this.getColumnWidth('pcsunitTx', 80),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '商品ABC',
        field: 'itemabcTx',
        width: this.getColumnWidth('itemabcTx', 80),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'バラ(通常)・格納ケース種類',
        field: 'baracaseTx',
        width: this.getColumnWidth('baracaseTx', 180),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'バラ(通常)・標準ケース入数',
        field: 'baraamountNr',
        width: this.getColumnWidth('baraamountNr', 180),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tr', 'cellclass']
      },
      {
        headerName: 'ケース(通常)・格納ケース種類',
        field: 'pycaseTx',
        width: this.getColumnWidth('pycaseTx', 200),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'ケース(通常)・標準ケース入数',
        field: 'pycaseamountNr',
        width: this.getColumnWidth('pycaseamountNr', 200),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tr', 'cellclass']
      },
      {
        headerName: 'バラ(保管)・格納ケース種類',
        field: 'bybaracaseTx',
        width: this.getColumnWidth('bybaracaseTx', 180),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'バラ(保管)・標準ケース入数',
        field: 'bybaracaseamountNr',
        width: this.getColumnWidth('bybaracaseamountNr', 180),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tr', 'cellclass']
      },
      {
        headerName: 'ケース(保管)・格納ケース種類',
        field: 'bycaseTx',
        width: this.getColumnWidth('bycaseTx', 200),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'ケース(保管)・標準ケース入数',
        field: 'bycaseamountNr',
        width: this.getColumnWidth('bycaseamountNr', 200),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tr', 'cellclass']
      },
      // {
      //   headerName: 'ピックヤード・バラ・入庫上限数',
      //   field: 'maxpbinstockNr',
      //   width: this.getColumnWidth('maxpbinstockNr', 210),
      //   valueFormatter: insertcomma,
      //   unSortIcon: true,
      //   suppressMenu: true, cellClass: ['tr', 'cellclass']
      // },
      {
        headerName: 'インナーケース入数',
        field: 'inneramountNr',
        width: this.getColumnWidth('inneramountNr', 140),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tr', 'cellclass']
      },
      {
        headerName: 'インナーケース数',
        field: 'innerNr',
        width: this.getColumnWidth('innerNr', 140),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tr', 'cellclass']
      },
      {
        headerName: 'ケース入数',
        field: 'caseamountNr',
        width: this.getColumnWidth('caseamountNr', 100),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tr', 'cellclass']
      },
      {
        headerName: 'パレット巻数',
        field: 'casespreadNr',
        width: this.getColumnWidth('casespreadNr', 100),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tr', 'cellclass']
      },
      {
        headerName: 'パレット段数',
        field: 'casestackNr',
        width: this.getColumnWidth('casestackNr', 100),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tr', 'cellclass']
      },
      {
        headerName: 'バラバーコード',
        field: 'pcsbarcodeTx',
        width: this.getColumnWidth('pcsbarcodeTx', 100),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tr', 'cellclass', 'textFormat']
      },
      {
        headerName: 'ケースバーコード',
        field: 'casebarcodeTx',
        width: this.getColumnWidth('casebarcodeTx', 160),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass', 'textFormat']
      },
      {
        headerName: '縦(cm)',
        field: 'lengthNr',
        width: this.getColumnWidth('lengthNr', 80),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '横(cm)',
        field: 'widthNr',
        width: this.getColumnWidth('widthNr', 80),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '高(cm)',
        field: 'heightNr',
        width: this.getColumnWidth('heightNr', 80),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '体積(m3)',
        field: 'volumeNr',
        width: this.getColumnWidth('volumeNr', 80),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '重量(kg)',
        field: 'weightNr',
        width: this.getColumnWidth('weightNr', 120),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tr', 'cellclass']
      },
      {
        headerName: 'インナーケースサイズ・縦(cm)',
        field: 'innerlengthNr',
        width: this.getColumnWidth('innerlengthNr', 210),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tr', 'cellclass']
      },
      {
        headerName: 'インナーケースサイズ・横(cm)',
        field: 'innerwidthNr',
        width: this.getColumnWidth('innerwidthNr', 210),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tr', 'cellclass']
      },
      {
        headerName: 'インナーケースサイズ・高さ(cm)',
        field: 'innerheightNr',
        width: this.getColumnWidth('innerheightNr', 210),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tr', 'cellclass']
      },
      {
        headerName: 'ケースサイズ・縦(cm)',
        field: 'caselengthNr',
        width: this.getColumnWidth('caselengthNr', 160),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tr', 'cellclass']
      },
      {
        headerName: 'ケースサイズ・横(cm)',
        field: 'casewidthNr',
        width: this.getColumnWidth('casewidthNr', 160),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tr', 'cellclass']
      },
      {
        headerName: 'ケースサイズ・高さ(cm)',
        field: 'caseheightNr',
        width: this.getColumnWidth('caseheightNr', 160),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tr', 'cellclass']
      },
      {
        headerName: 'ケースサイズ・体積(m3)',
        field: 'casevolumeNr',
        width: this.getColumnWidth('casevolumeNr', 50),
        suppressMenu: true, cellClass: ['tr', 'cellclass']
        //valueFormatter: insertcomma,
      },
      {
        headerName: 'ケースサイズ・重量(kg)',
        field: 'caseweightNr',
        width: this.getColumnWidth('caseweightNr', 50),
        suppressMenu: true, cellClass: ['tr', 'cellclass']
        //valueFormatter: insertcomma,
      },
      {
        headerName: '単価区分',
        field: 'typeunitpriceTx',
        width: this.getColumnWidth('typeunitpriceTx', 100),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '保管料単価(円)',
        field: 'stockunitpriceNr',
        width: this.getColumnWidth('stockunitpriceNr', 120),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '入庫単価(円)',
        field: 'arriveunitpriceNr',
        width: this.getColumnWidth('arriveunitpriceNr', 120),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '出庫単価(円)',
        field: 'shipunitpriceNr',
        width: this.getColumnWidth('shipunitpriceNr', 120),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '寄託金額(円)',
        field: 'depositpriceNr',
        width: this.getColumnWidth('depositpriceNr', 120),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '補充点(バラエリア)',
        field: 'bsupppointbaraNr',
        width: this.getColumnWidth('bsupppointbaraNr', 150),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '上限値(バラエリア)',
        field: 'bsupplimitbaraNr',
        width: this.getColumnWidth('bsupplimitbaraNr', 150),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '補充点(インナーケースエリア)',
        field: 'supppointinnercaseNr',
        width: this.getColumnWidth('supppointinnercaseNr', 200),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '上限値(インナーケースエリア)',
        field: 'supplimitinnercaseNr',
        width: this.getColumnWidth('supplimitinnercaseNr', 200),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '補充点(ケースエリア)',
        field: 'supppointcaseNr',
        width: this.getColumnWidth('supppointcaseNr', 150),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '上限値(ケースエリア)',
        field: 'supplimitcaseNr',
        width: this.getColumnWidth('supplimitcaseNr', 150),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tr', 'cellclass']
      },
      //New column, will check the propaties name
      {
        headerName: 'バリエーション名1',
        field: 'variation1Tx',
        width: this.getColumnWidth('variation1Tx', 150),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'バリエーション名2',
        field: 'variation2Tx',
        width: this.getColumnWidth('variation2Tx', 150),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'バリエーション名3',
        field: 'variation3Tx',
        width: this.getColumnWidth('variation3Tx', 140),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '表示用金額',
        field: 'displaypriceNr',
        width: this.getColumnWidth('displaypriceNr', 100),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '荷主コード',
        field: 'ownerCd',
        width: this.getColumnWidth('ownerCd', 140),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '荷主名',
        field: 'ownerTx',
        width: this.getColumnWidth('ownerTx', 160),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '更新日時',
        field: 'updDt',
        width: this.getColumnWidth('updDt', 160),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '更新者名',
        field: 'upduserTx',
        width: this.getColumnWidth('upduserTx', 160),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '登録日時',
        field: 'addDt',
        width: this.getColumnWidth('addDt', 160),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '登録者名',
        field: 'adduserTx',
        width: this.getColumnWidth('adduserTx', 160),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
    ];
    this.gridOptions.excelStyles = [
      {
        //Text
        id: 'textFormat',
        dataType: 'string'
      }
    ];
    this.gridHelper.setGridOptions(this.gridOptions);
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
    this.gridHeight = window.innerHeight - config.headerMargin - config.containerButtonMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }

  }

  getColumnWidth(id: string, def: number): number {
    return parseInt(localStorage.getItem(`wa9100_${id}_width`), 10) || def;
  }

  saveColumnWidth(params) {
    if (params.finished === true && params.type === 'columnResized') {
      localStorage.setItem(`wa9100_${params.column.colId}_width`, params.column.actualWidth);
    }
  }

  saveColumnOrder() {
    let idx = 0;
    for (const column of this.gridApi.columnApi.getAllDisplayedColumns()) {
      if (column.colId !== '0') {
        localStorage.setItem(`wa9100_${column.colId}_idx`, `${idx}`);
      }
      idx++;
    }
  }

  getContextMenuItems(params) {
    const str_to_unicode_array = str => {
      const arr = [];
      for (let i = 0; i < str.length; i++) {
        arr.push(str.charCodeAt(i));
      }
      return arr;
    };

    const download = csvString => {
      // Unicode コードポイントの配列に変換する
      const unicode_array = str_to_unicode_array(csvString);
      // S-JIS コードポイントの配列に変換
      const sjis_code_array = encoding.convert(
        unicode_array, // ※文字列を直接渡すのではない点に注意
        'SJIS', // to
        'UNICODE' // from
      );
      // 文字コード配列をTypedArrayに変換する
      const uint8_array = new Uint8Array(sjis_code_array);
      // 指定されたデータを保持するBlobを作成する
      const blob = new Blob([uint8_array], { type: 'text/csv' });
      // Internet Explorer
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, 'export.csv');
      } else {
        // Chrome
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = 'export.csv';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
    };
    const result = [
      'copy',
      'copyWithHeaders',
      'separator',
      {
        name: 'チェックした行をCSVエクスポート',
        action: () => {
          download(params.api.getDataAsCsv({ onlySelected: true }));
        }
      },
      {
        name: 'チェックした行をExcelエクスポート',
        action: () => {
          params.api.exportDataAsExcel({ onlySelected: true });
        }
      }  
      // {
      //   name: '取得した行を全てダウンロード',
      //   action: () => {
      //     ExportData.toCsv(params.api)
      //   }
      // },
      // {
      //   name: 'すべて選択', action: () => {
      //     console.log("params.api======="); console.log(params.api); console.log("params.api=======");
      //     console.log("params.paramsMap======="); console.log(params.api.dataSource); console.log("params.paramsMap=======");
      //     console.log(params.node.id);
      //     params.node.id = 5;
      //     params.node.setSelected(true);
      //   }
      // },
      // {
      //   name: 'エクスポート',
      //   subMenu: [
      //     {
      //       name: 'チェックした行をCSVエクスポート',
      //       action: () => {
      //         download(params.api.getDataAsCsv({ onlySelected: true }));
      //       }
      //       },
      //       {
      //         name: 'すべてCSVエクスポート',
      //         action: () => {
      //           ExportData.toCsv(params.api)
      //         }
      //     }
      //   ]
      // }
    ];

    return result;
  }

  rowSelected(event) {
    console.log("t1 " + event.node.isSelected());
    if (event.node.isSelected()) {
      event.node.setSelected(false);
    } else {
      event.node.setSelected(true);
    }
  }

  checkAll() {
    console.log("全部チェック");
  }

  ngAfterViewInit() {
    this.gridHelper.el = this.gridView;
    setTimeout(() => {
      this.onSubmit();
    }, config.waitMsForSearchInNgAfterViewInit);
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
  }

  onResizeGrid(event) {
    this.gridHeight = event.target.innerHeight - config.headerMargin - config.containerButtonMargin
  }

  changeOwner(selectedOwnerId) {
    console.log(selectedOwnerId);
    if (selectedOwnerId !== null) {
      if (selectedOwnerId !== undefined) {
        this.ownerId = selectedOwnerId;
      }
      else {
        this.ownerId = undefined;
      }
      this.postDataSource['querystrings'] = { 'ownerId': this.ownerId };
      if (!this.isDatasourceInit) {
        this.gridOptions.api.setDatasource(this.postDataSource);
        this.isDatasourceInit = true;
      } else {
        this.gridOptions.api.onSortChanged();
      }
    }
    else {
      this.ownerId = null;
      this.rowData = [];
      this.gridOptions.api.deselectAll();
      this.postDataSource['querystrings'] = { 'ownerId': this.ownerId };
      if (!this.isDatasourceInit) {
        this.gridOptions.api.setDatasource(this.postDataSource);
        this.isDatasourceInit = true;
      } else {
        this.gridOptions.api.onSortChanged();
      }
    }
  }

  onEditButtonClick(node, $event) {
    this.deleteErrorMsgForPopup = '';
    this.editNode = node;
    event.stopPropagation();
    sessionStorage.setItem('rowItems', JSON.stringify(node['data']));
    this.showWa9102();
  }

  onSubmit() {
    //SW-2103　ダブルクリック抑止
    if (this.working) return;
    this.working = true;

    // this.gridOptions.api.deselectAll();

    setTimeout(() => {
      const querystrings = (this.ownerId) ? { 'ownerId': this.ownerId } : '';
      this.postDataSource['querystrings'] = querystrings;
      if (!this.isDatasourceInit) {
        this.gridOptions.api.setDatasource(this.postDataSource);
        this.isDatasourceInit = true;
      } else {
        this.gridOptions.api.onSortChanged();
      }
    }, 1500);
    if (this.isRefreshAndCheckUpdateData == true) {
      setTimeout(() => {
        this.gridHelper.selectedAnimate();
      }, 100);
    }
    this.isRefreshAndCheckUpdateData = false;
    setTimeout(() => {
      this.working = false;
    },300);
  }

  reg() {
    this.router.navigate(['wa9101']);
    sessionStorage.setItem('isWa9101FirstOpen', 'true');
  }

  del() {
    this.errorInfo = '';
    var isDeleteFromPopWin = false;
    isDeleteFromPopWin = this.isShowWa9102;

    let selectedId = 0;

    if (isDeleteFromPopWin) {
      selectedId = this.editNode['data']['itemId'];
    } else {
      if (this.gridOptions.api.getSelectedNodes().length !== 1) {
        this.errorInfo = '対象を1行だけ選択して下さい';
        this.isShowDeleteModal = false;
        return;
      }

      selectedId = this.gridOptions.api.getSelectedNodes()[0]['data']['itemId'];
    }
    // ダブルクリック抑止
    if (this.working) {
      if (!isDeleteFromPopWin) { 
        this.isShowDeleteModal = false;
      }
      return;
    }

    this.working = true;
    this.itemService
      .deleteForSpring(selectedId)
      .then(outputJson => {
        this.working = false;
        if (isDeleteFromPopWin) {
          this.isShowWa9102 = false;
        }

        if (isDeleteFromPopWin) this.deleteErrorMsgForPopup = '';
        else this.errorInfo = '';

        this.onSubmit();

        if (!isDeleteFromPopWin) sessionStorage.setItem('SuccessInfoMessage', '削除が完了しました');
        this.isShowDeleteModal = false;
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));

        if (isDeleteFromPopWin) this.deleteErrorMsgForPopup = this.commonService.getErrorMessage(error);
        else this.errorInfo = this.commonService.getErrorMessage(error);
        this.isShowDeleteModal = false;
      });
  }

  // 商品ラベル出力
  printItemLabel() {
    if (this.gridOptions.api.getSelectedNodes().length === 0) {
      this.working = false;
      this.dialogsService
        .info('エラー', '対象を選択して下さい');
      return;
    }
    this.working = true;
    const selectIds: object[] = [];
    for (let i = 0; i < this.gridOptions.api.getSelectedNodes().length; i++) {
      const rowIndex: number = +this.gridOptions.api.getSelectedNodes()[i]['id'];
      // push data
      const jsonUnit: object = {
        selectId: this.rowData[rowIndex]['itemId'],
      }
      selectIds.push(jsonUnit);
    }
    sessionStorage.setItem('wa9100-itemId-itemLabel', JSON.stringify(selectIds));
    this.working = false;
    this.router.navigate(['wa9105']);
  }

  onFilterClear() {
    this.gridOptions.api.setFilterModel(null);
  }

  paginatorRowChange() {
    this.gridOptions.cacheBlockSize = Number(this.rowsPerPage);
    this.gridOptions.api.paginationSetPageSize(this.rowsPerPage);
    this.gridOptions.api.onSortChanged();
  }

  showWa9101() {
    this.errorInfo = '';
    this.isShowWa9101 = true;
    sessionStorage.removeItem('isShowOwnerSelect');
  }

  onClose9101(isRefreshGrid: boolean) {
    this.isShowWa9101 = false;
    if (isRefreshGrid) {
      this.isRefreshAndCheckNewData = true;
      this.onSubmit();
    }
    sessionStorage.setItem('isShowOwnerSelect', 'true');
  }

  showWa9102() {
    this.errorInfo = '';
    this.isShowWa9102 = true;
    sessionStorage.removeItem('isShowOwnerSelect');
  }

  onClose9102(isRefreshGrid: boolean) {
    this.isShowWa9102 = false;
    if (isRefreshGrid) {
      this.isRefreshAndCheckUpdateData = true;
      this.gridHelper.prepareSelectedAnimate();
      this.onSubmit();
    }
    sessionStorage.setItem('isShowOwnerSelect', 'true');
  }

  showWa9183() {
    this.isShowWa9183 = true;
    sessionStorage.removeItem('isShowOwnerSelect');
  }

  onClose9183(isRefreshGrid: boolean) {
    this.isShowWa9183 = false;
    if (isRefreshGrid) this.onSubmit();
    sessionStorage.setItem('isShowOwnerSelect', 'true');
  }

  ownerInputChanged(ownerId: string) {
    this.gridHelper.isOwnerNotFound = ownerId == null && ownerId !== undefined;
    this.changeOwner(ownerId);
  }

  csvDownload(csvString) {
    const str_to_unicode_array = str => {
      const arr = [];
      for (let i = 0; i < str.length; i++) {
        arr.push(str.charCodeAt(i));
      }
      return arr;
    };

    // Unicode コードポイントの配列に変換する
    const unicode_array = str_to_unicode_array(csvString);
    // S-JIS コードポイントの配列に変換
    const sjis_code_array = encoding.convert(
      unicode_array, // ※文字列を直接渡すのではない点に注意
      'SJIS', // to
      'UNICODE' // from
    );
    // 文字コード配列をTypedArrayに変換する
    const uint8_array = new Uint8Array(sjis_code_array);
    // 指定されたデータを保持するBlobを作成する
    const blob = new Blob([uint8_array], { type: 'text/csv' });
    // Internet Explorer
    if (window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob, 'export.csv');
    } else {
      // Chrome
      const downloadLink = document.createElement('a');
      downloadLink.href = window.URL.createObjectURL(blob);
      downloadLink.download = 'export.csv';
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    }
  }
  showCSVDownloadModal() {
    this.errorInfoForCSV = '';
    this.csvDownloadType = null;
    this.isShowCSVDownloadModal = true;
  }
  CSVDownlod() {
    //SW-2103　ダブルクリック抑止
    if (this.working) return;
    this.working = true;

    this.errorInfoForCSV = '';
    this.csvDownloadType = '0';
    if (this.csvDownloadType == null) {
      this.errorInfoForCSV = 'ダウンロードする範囲を選択してください。';
      this.working = false;
      return;
    }

    var csvString = '';
    if (this.csvDownloadType == '0') {
      if (this.gridOptions.api.getSelectedNodes().length == 0) {
        this.errorInfoForCSV = '対象を選択して下さい。';
        this.working = false;
        return;
      }
      csvString = this.gridApi.api.getDataAsCsv({
        onlySelected: true
      });
    } else {
      var headerFields = [];
      var headerIndex = 0;
      this.gridOptions.columnDefs.forEach(value => {
        csvString += value['headerName'];

        if (headerIndex != this.gridOptions.columnDefs.length - 1) csvString += ',';

        headerFields.push(value['field']);
        headerIndex++;
      });
      csvString += '\r\n';

      this.gridOptions.api.getModel().forEachNode(rowNode => {
        headerIndex = 0;
        var data = rowNode.data;
        var _dataString = '';
        headerFields.forEach(fieldName => {
          _dataString += data[fieldName] == null ? '' : data[fieldName];
          if (headerIndex != headerFields.length - 1) _dataString += ',';
          headerIndex++;
        });
        _dataString += '\r\n';
        csvString += _dataString;
      });
    }
    this.csvDownload(csvString);
    this.isShowCSVDownloadModal = false;
    setTimeout(() => {
      this.working = false;
    },300);
  }

  AllCsvDownload(){
    //処理中表示
    this.working = true;
    //ローディング表示
    this.isShowSendLoading = true;

    this.csvReportService
    .postSpring('RA9006', this.ownerId, 'dummy','','','wa9100')
    .then(resultCsv => {

      this.working = true;
      
       const blob = new Blob(this.commonService.toSJis(resultCsv.fileContents), {type: 'text/csv'});
      
       // Internet Explorer
       if (window.navigator.msSaveOrOpenBlob) {
         window.navigator.msSaveOrOpenBlob(blob, resultCsv.fileName);
       } else {
         // Chrome
         const downloadLink = document.createElement('a');
         downloadLink.href = window.URL.createObjectURL(blob);
         downloadLink.download = resultCsv.fileName;
         document.body.appendChild(downloadLink);
         downloadLink.click();
         document.body.removeChild(downloadLink);
       }
       
       this.working = false;
       this.isShowSendLoading = false;    
   })
   .catch(error => {
     this.working = false;
     this.isShowSendLoading = false; 
     console.log(this.commonService.getErrorMessage(error));
     this.errorInfo = this.commonService.getErrorMessage(error);
   }); 
  }

  fixedSelectAll() {
    var selectAll = this.gridView.nativeElement.querySelector('.ag-header-row .ag-header-select-all');
    selectAll.classList.remove('ag-hidden')
    selectAll.addEventListener('click', () => {
      const nodes = this.gridOptions.api.getRenderedNodes()
      if (nodes.length > 0 && nodes[0].data === null) {
        this.gridSelectAll = !this.gridSelectAll
        return
      }

      this.gridSelectAll = !this.gridSelectAll
      this.selectCurrentPage(this.gridSelectAll)
    })
  }

  selectCurrentPage (selected) {
    const startRow = (this.paginationGetCurrentPage - 1) * Number(this.rowsPerPage)
    const endRow = startRow + Number(this.rowsPerPage)

    this.gridOptions.api.forEachNode(node => {
      if (node.data)
        node.setSelected(false)
    })
    const count = this.gridOptions.api.getDisplayedRowCount()
    const limit = count < endRow ? count : endRow

    for (let i = startRow; i < endRow; i++) {
      const node = this.gridOptions.api.getDisplayedRowAtIndex(i)
      if (node.data)
        node.setSelected(selected)
    }
  }

  

  onShowDeleteModal() {
    this.deleteErrorMsgForPopup = '';
    this.errorInfo = '';
    this.isShowDeleteModal = true;
  }

  onShowDeleteModalFrom9102() {
    if (this.editNode == null) {
      return;
    }
    this.isShowDeleteModal = true;
  }

  selectAllClick () {
    var selectAll = this.gridView.nativeElement.querySelector('.ag-header-row .ag-header-select-all');
    selectAll.click()
  }

  handleBeforeRequest () {
    this.gridOptions.api.showLoadingOverlay();
    this.setHeaderLoadingStart();
  }

  handleRequestSucc () {
    this.gridOptions.api.hideOverlay();
    this.setHeaderLoadingEnd();
  }

      // ヘッダ表示をデータ取得中の状態に変更
      setHeaderLoadingStart () {
        // ヘッダを非表示にする
        this.gridView.nativeElement.querySelector('.ag-header').style.display = 'none';
        // スクロールバーを表示しない
        this.gridView.nativeElement.querySelector('.ag-body-viewport').style.overflow = 'hidden';
        // 念のためフィルターの入力を不可にする
        var filterInput = this.gridView.nativeElement.querySelectorAll('.ag-header-cell input, .ag-header-cell button');
        for(let i in filterInput){
          if (filterInput.hasOwnProperty(i)) {
            filterInput[i].disabled = true;
          }
        }
      }
  
      // ヘッダ表示をデータ取得中の状態から戻す
      setHeaderLoadingEnd () {
        // ヘッダの表示を戻す
        this.gridView.nativeElement.querySelector('.ag-header').style.display = 'block';
        // スクロールバーを再表示
        this.gridView.nativeElement.querySelector('.ag-body-viewport').style.overflow = 'auto';
        // フィルターの入力を可能にする
        var filterInput = this.gridView.nativeElement.querySelectorAll('.ag-header-cell input, .ag-header-cell button');
        for(let i in filterInput){
          if (filterInput.hasOwnProperty(i)) {
            filterInput[i].disabled = false;
          }
        }
      }

}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9100/wa9100.component.ts